export default __webpack_public_path__ + "static/media/Rectangle.f4dc8352.svg";